import { isNil } from 'lodash';
import { useMemo } from 'react';
import { useSelector } from 'react-redux';
// Import Services
import { Helpers } from 'services';

const { replaceDayTokens } = Helpers;

export const usePartnerDateFormats = () => {
    const { Date, DateTime, DateTimeWithoutSeconds } = useSelector(
        (state) => state?.partnerSettings?.DataFormats ?? {},
    );

    const memoizedValue = useMemo(() => {
        if (isNil(Date) || isNil(DateTime) || isNil(DateTimeWithoutSeconds)) {
            return {
                partnerDateFormat: null,
                partnerDateTimeFormat: null,
                partnerDateTimeWithoutSecondsFormat: null,
            };
        }

        const partnerDateFormat = replaceDayTokens(Date);
        const partnerDateTimeFormat = replaceDayTokens(DateTime);
        const partnerDateTimeWithoutSecondsFormat = replaceDayTokens(DateTimeWithoutSeconds);

        return {
            partnerDateFormat,
            partnerDateTimeFormat,
            partnerDateTimeWithoutSecondsFormat,
        };
    }, [Date, DateTime, DateTimeWithoutSeconds]);

    return memoizedValue;
};
